<div class="container-fluid studies-container">
    <div class="row">
        <div class="col-sm-12 col-lg-4">
            <div class="cc-card">
                <div class="header">
                    <h1>Contrôle de concession</h1>
                    <div class="sub-header">Accéder à vos exercices</div>
                </div>

                <div class="studies">
                    <div *ngFor="let study of ccStudies" class="study">
                        <div class="header">
                            <h2>{{ study.year }}</h2>

                            <ng-container
                                *ngTemplateOutlet="
                                    ccStudyHeaderTemplate;
                                    context: { study: study }
                                ">
                            </ng-container>
                        </div>

                        <ng-container
                            *ngTemplateOutlet="
                                ccStudyBodyTemplate;
                                context: { study: study }
                            "></ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-lg-4">
            <div class="crac-card">
                <div class="header">
                    <h1>Cartes nationales des principaux indicateurs issus des CRAC</h1>
                    <div class="sub-header"></div>
                </div>

                <div class="studies">
                    <div *ngFor="let cracmap of cracMaps" class="study">
                        <div class="header">
                            <h2>{{ cracmap.year }}</h2>
                            <ng-container
                                *ngTemplateOutlet="
                                    cracmapHeaderTemplate;
                                    context: { cracmap: cracmap }
                                ">
                            </ng-container>
                        </div>
                        <ng-container
                            *ngTemplateOutlet="cracmapBodyTemplate; context: { cracmap: cracmap }">
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12 col-lg-4">
            <div class="crac-card">
                <div class="header">
                    <h1>Benchmarks des indicateurs issus des CRAC</h1>
                    <div class="sub-header"></div>
                </div>

                <div class="studies">
                    <div class="wip">
                        <img
                            src="/assets/img/logo_wip.png"
                            alt="Cette fonctionnalité est en cours d'implémentation"
                            class="wip-img" />
                        <div class="wip-text">
                            <i>
                                Nos équipes sont actuellement à l'oeuvre pour bâtir une nouvelle
                                fonctionnalité rien que pour vous.

                                <br />
                                <br />
                                En attendant, vous pouvez déjà bénéficier de ces fonctionnalités
                                directement sur votre compte "Tableau":
                                <br />
                                <br />
                            </i>
                            <ed-button
                                (click)="goToTableau()"
                                [small]="true"
                                [colorSchema]="buttonColors.Primary">
                                Accéder à Tableau
                            </ed-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
